import * as React from "react";
import * as showdown from "showdown";
import { UserMessagePage } from "./userMessageTypes";

type Props = {
  page: UserMessagePage;
  pageNumber?: number;
  livePreview?: boolean;
  safeMode: boolean; // Determines whether server-side sanitized html is used instead of showdown
};

type State = {};

const textPadding = 15;

const PLACEHOLDER_IMAGE = require("../../../resources/missing_image.svg");

class Page extends React.Component<Props, State> {
  showdownConverter: showdown.Converter;

  constructor(props: any) {
    super(props);
    this.state = {};
    this.showdownConverter = new showdown.Converter({
      strikethrough: true,
      emoji: true,
      underline: true,
      smoothLivePreview: !!props.livePreview
    });
  }

  render() {
    const { page } = this.props;
    return (
      <section
        style={{
          border: "2px solid #000000",
          boxSizing: "border-box",
          textAlign: "left"
        }}
      >
        {page ? (
          <div>
            <div
              style={{
                position: "relative",
                paddingBottom: "56.25%",
                height: 0
              }}
            >
              <img
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  maxWidth: "100%"
                }}
                alt="Page"
                src={page.image ? page.image : PLACEHOLDER_IMAGE}
              />
            </div>
            <div
              style={{
                paddingLeft: `${textPadding}px`,
                paddingRight: `${textPadding}px`,
                wordBreak: "break-all"
              }}
              dangerouslySetInnerHTML={{
                __html: this.props.safeMode
                  ? page.safe_mobile_html
                  : this.showdownConverter.makeHtml(page.body)
              }}
            />
          </div>
        ) : (
          <div>Failed to load page</div>
        )}
      </section>
    );
  }
}

export default Page;
